import * as React from "react";

import { Button, FormGroup, InputGroup } from "@blueprintjs/core";
import MyLocationTwoTone from "@material-ui/icons/MyLocationTwoTone";
import { WithTranslation, withTranslation } from "react-i18next";
import Topic from "~/components/CustomerSupport/Topic";
import { StyledCard as Card } from "~/layouts/StyledCard";
import styled from "~/styled";

export interface IFormState {
  orderNumber: string;
  postalCode: string;
}

interface IProps {
  onSubmit: () => any;
  onChange: (formState: Partial<IFormState>) => any;
  orderNumber: string;
  postalCode: string;
}

const Form = styled.form`
  margin-top: 24px;
`;

class TrackTraceForm extends React.Component<IProps & WithTranslation> {
  public render() {
    const { t, orderNumber, postalCode } = this.props;

    return (
      <Card>
        <Topic
          icon={MyLocationTwoTone}
          title={t("form.title")}
          description_html={t("form.description_html")}
        />

        <Form method="post" onSubmit={this.handleSubmit}>
          <FormGroup label={t("fields.orderNumber.label")}>
            <InputGroup
              value={orderNumber}
              onChange={this.handleChange("orderNumber")}
            />
          </FormGroup>

          <FormGroup label={t("fields.postalCode.label")}>
            <InputGroup
              value={postalCode}
              onChange={this.handleChange("postalCode")}
            />
          </FormGroup>

          <Button type="submit" intent="primary" fill={true} large={true}>
            {t("submit")}
          </Button>
        </Form>
      </Card>
    );
  }

  private handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();

    this.props.onSubmit();
  };

  private handleChange = (key: "orderNumber" | "postalCode") => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    this.props.onChange({
      [key]: event.currentTarget.value
    });
  };
}

export default withTranslation("trackTrace")(TrackTraceForm);



// WEBPACK FOOTER //
// ./src/components/TrackTrace/TrackTraceForm.tsx